import { ElementTypes } from '../element-types';

export class Payment {
  private static readonly prefix: string = 'payment';
  static readonly PaymentForm: string = `${Payment.prefix}-${ElementTypes.Div}-payment-form`;
  static readonly CardNumber: string = `${Payment.prefix}-${ElementTypes.Input}-card-number`;
  static readonly NameOnCard: string = `${Payment.prefix}-${ElementTypes.Input}-name-on-card`;
  static readonly Cvc: string = `${Payment.prefix}-${ElementTypes.Input}-security-code`;
  static readonly CardExpiryMonth: string = `${Payment.prefix}-${ElementTypes.Dropdown}-expiry-month`;
  static readonly CardExpiryYear: string = `${Payment.prefix}-${ElementTypes.Dropdown}-expiry-year`;
  static readonly BuyNow: string = `${Payment.prefix}-${ElementTypes.Button}-buy-now`;
  static readonly MainContent: string = `${Payment.prefix}-${ElementTypes.Div}-main-content`;
}
